module.exports = __webpack_public_path__ + "img/OTHER.04dbd28d.png";